import React, { createContext, useEffect, useState } from 'react'
import User from './User'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getUserFetch, getUserRolesFetch } from 'store/middlewares/user.crud'
import { getAffiliationsFetch } from 'store/middlewares/affiliation.crud'
import { getAllTestTakersFetch, getGradesFetch, getLearningGroupsFetch, getSchoolClassesFetch, getTestTakerOptionsWithClassFetch } from 'store/middlewares/testTakers.crud'
import { isEmpty, isObject, uniqueId } from 'lodash'
import { useParams } from 'react-router-dom'
import { UserVM } from 'models/VM'
import { getUserRoles } from 'models/VM/User'
import { useSelector } from 'react-redux'
import { getCurrentSchoolYear } from 'utils/general'
import { semesterAndYearOptions } from 'keys/years'

export const emptyRole = { id: uniqueId(), school_year: semesterAndYearOptions.find(year => year.id == getCurrentSchoolYear()) }

const UserPage = (props) => {
    const formname = "createUser"

    const { userID, affiliationID } = useParams()

    const initialUserRoles = [{ id: 1, roles: [emptyRole] }]

    const [userRoles, setUserRoles] = useState(initialUserRoles)
    const [roleAcordions, setRoleAcordions] = useState({})
    const [tzApproved, setTzApproved] = useState(userID ? true : false)

    const { groups } = useSelector(state => state.affiliation)
    // const isSchoolsGroup = ?.name == affiliationGroups.schools

    const queryClient = useQueryClient()
    const isNewUser = !userID
    const roles = queryClient.getQueryData([qc.roles])

    const affiliations = useQuery({
        queryKey: [qc.affiliations, "crud-user"],
        queryFn: async () => {
            const { data } = await getAffiliationsFetch()

            // URL שהגיע ב ID מיועד עבור הוספת איש צוות - מתוך בית ספר מסויים, כאן אנחנו מאתרים את המוסד לפי ה
            // מבצעים כאן ארבעה בדיקות:
            // ?של מוסד ID ,URL האם יש ב  
            // רק במידה ואין אנחנו מאתרים את המוסד ושומרים , ?userRolesהאם אין לנו את פרטי המוסד ב

            // הורדתי כרגע את הבדיקה הזו - לא בטוחה שזה נכון שהורדתי צריך לבדוק
            // האם מדובר במשתמש חדש שלא נוצר עדיין - רק אצלו אין עדיין שיוך למוסד


            if (affiliationID && !isObject(userRoles[0].affiliation)) {
                let affiliationObj = data.find((aff) => aff.id == affiliationID)
                setUserRoles([{ ...userRoles[0], affiliation: affiliationObj }])
            }

            return data
        },
        refetchOnWindowFocus: false
    })

    const grades = useQuery({
        queryKey: [qc.grades],
        queryFn: async () => {
            const { data } = await getGradesFetch()
            return data
        },
        refetchOnWindowFocus: false
    })

    const classes = useQuery({
        queryKey: [qc.classes],
        queryFn: async () => {
            const { data } = await getSchoolClassesFetch()
            return data
        },
        refetchOnWindowFocus: false
    })

    const learningGroups = useQuery({
        queryKey: [qc.learningGroups, "crud-user"],
        queryFn: async () => {
            const { data } = await getLearningGroupsFetch()
            return data
        },
        refetchOnWindowFocus: false,
    })

    const testTakers = useQuery({
        queryKey: [qc.allTestTakers],
        queryFn: async () => {
            const { data } = await getAllTestTakersFetch()
            // const { data } = await getTestTakerOptionsWithClassFetch()

            return data
        },
        refetchOnWindowFocus: false
    })

    const user = useQuery({
        queryKey: [qc.user, userID, affiliationID],
        queryFn: async () => {
            const { data } = await getUserFetch(userID)
            const nUser = new UserVM(data)
            return nUser
        },
        enabled:
            !!userID &&
            !!affiliations.data &&
            !!testTakers.data &&
            !!roles
        // !!grades.data &&
        // !!classes.data 
    })

    const _ = useQuery({
        queryKey: [qc.userRoles2, userID, affiliationID],
        queryFn: async () => {
            let params = {}
            if (affiliationID)
                params.affiliation = affiliationID
            params.custom_user = userID
            const { data } = await getUserRolesFetch(params, userID)
            const userRoles = getUserRoles(data, {
                affiliations: affiliations.data,
                affiliationGroups: groups,
                grades: grades.data,
                learningGroups: learningGroups.data,
                schoolClasses: classes.data,
                testTakers: testTakers.data,
                roles: roles
            })
            if (!isEmpty(userRoles))
                setUserRoles(userRoles)
            return userRoles
        },
        enabled: !!userID && !!grades.data && !!affiliations.data && !!classes.data && !!testTakers.data && !!roles
    })

    useEffect(() => {
        setTimeout(() => {
            if (userID)
                setTzApproved(true)
        }, 300);
    }, [])

    const commonValue = {
        roles,
        affiliations,
        grades,
        classes,
        testTakers,
        userRoles, setUserRoles,
        roleAcordions, setRoleAcordions,
        isNewUser,
        user,
        formname,
        tzApproved, setTzApproved,
        learningGroups
    }

    return (
        <UserContext.Provider value={commonValue}>
            <User {...props} />
        </UserContext.Provider>
    )

}
export const UserContext = createContext()
export default UserPage